import { useContext } from 'react';

import { TimeframeContext } from './context';

export const useResetTimeframe = () => {
  const { onReset } = useContext(TimeframeContext);
  return onReset;
};
